import {ContentType} from "../../common/enums/post.enum";
import Title from "../common/posts/title";
import VersionedCode from "../common/posts/versioned-code";
import SimpleCode from "../common/posts/simple-code";
import Heading from "../common/posts/heading";
import Summary from "../common/posts/summary";
import Paragraph from "../common/posts/paragraph";
import Image from "../common/posts/image";
import SimpleTable from "../common/posts/simple-table";
import UnorderedList from "../common/posts/unordered-list";
import Markdown from "../common/posts/markdown";

function Content(props: Props) {
  return props.data.map((data: any, index: number) => {
    const {content_type} = data;
    switch (content_type) {
      case ContentType.title:
        return <Title data={data.content}/>
      case ContentType.versionedCode:
        return <VersionedCode versions={data.versions}/>
      case ContentType.simpleCode:
        return <SimpleCode content={data.content} language={data.language}/>
      case ContentType.heading:
        return <Heading data={data.content} level={data.level}/>
      case ContentType.summary:
        return <Summary data={data.content}/>
      case ContentType.paragraph:
        return <Paragraph data={data.content}/>
      case ContentType.image:
        return <Image data={data}/>
      case ContentType.simpleTable:
        return <SimpleTable data={data} width={data.width}/>
      case ContentType.unorderedList:
        return <UnorderedList data={data}/>
      case ContentType.markdown:
        return <Markdown data={data}/>
      default:
        return <div>No data</div>
    }
  })
}

export default Content;

class Props {
  data: any;
}
